import React from 'react';
import { Menu } from 'antd';
import {
  LineChartOutlined,
  AreaChartOutlined,
  BarChartOutlined,
  PieChartOutlined,
  TableOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import ButtonDropdown from './ButtonDropdown';

const ChartTypes = [
  { name: 'table', title: 'Table', icon: <TableOutlined /> },
  // { name: 'line', title: 'Line', icon: <LineChartOutlined /> },
  // { name: 'area', title: 'Area', icon: <AreaChartOutlined /> },
  // { name: 'bar', title: 'Bar', icon: <BarChartOutlined /> },
  // { name: 'pie', title: 'Pie', icon: <PieChartOutlined /> },
  // { name: 'indicator', title: 'Indicator', icon: <InfoCircleOutlined /> },
];

const SelectChartType = ({ chartType, updateChartType }: any) => {
  const menu = (
    <Menu data-testid="chart-type-dropdown">
      {ChartTypes.map((m) => (
        <Menu.Item key={m.title} onClick={() => updateChartType(m.name)}>
          {m.icon} {m.title}
        </Menu.Item>
      ))}
    </Menu>
  );

  const foundChartType = ChartTypes.find((t) => t.name === chartType);
  return (
    <ButtonDropdown data-testid="chart-type-btn" overlay={menu} icon={foundChartType?.icon} style={{ border: 0 }}>
      {foundChartType?.title || ''}
    </ButtonDropdown>
  );
};

export default SelectChartType;
